import { gql } from "@urql/core";
import { questionnaireFragment, wizardBodyFragment } from "api/queries";

const WizardStepMut = gql`
  mutation processWizardStep($input: ProcessWizardStepInput!) {
    processWizardStep(input: $input) {
      ...wizardBodyFragment
      currentQuestionnaire {
        ...questionnaireFragment
      }
      questionnaires {
        ...questionnaireFragment
      }
    }
  }
  ${questionnaireFragment}
  ${wizardBodyFragment}
`;

const createWizardStepQuestionnaire = gql`
  mutation addWizardStepQuestionnaire($input: AddQuestionnaireInput!) {
    addWizardStepQuestionnaire(input: $input) {
      ...questionnaireFragment
      __typename
    }
  }
  ${questionnaireFragment}
`;

const changeWizardActiveQuestionnaireMut = gql`
  mutation changeWizardActiveQuestionnaireMut(
    $nodeId: String!
    $step: Int!
    $id: String!
  ) {
    changeWizardActiveQuestionnaireMut(nodeId: $nodeId, step: $step, id: $id)
    ...wizardBodyFragment
    currentQuestionnaire {
      ...questionnaireFragment
    }
    questionnaireLists {
      ...questionnaireFragment
    }
  }
  ${questionnaireFragment}
  ${wizardBodyFragment}
`;

const updateWizardStepQuestionnaireMut = gql`
  mutation modifyWizardStepQuestionnaire($input: ModifyQuestionnaireInput!) {
    modifyWizardStepQuestionnaire(input: $input) {
      id
      title
    }
  }
`;

const deleteWizardStepQuestionnaireMut = gql`
  mutation removeWizardStepQuestionnaire($input: RemoveQuestionnaireInput!) {
    removeWizardStepQuestionnaire(input: $input) {
      id
      position
    }
  }
`;

const duplicateWizardStepQuestionnaireMut = gql`
  mutation cloneWizardStepQuestionnaires($input: CloneQuestionnairesInput!) {
    cloneWizardStepQuestionnaires(input: $input) {
      identifier
      title
      id
      position
    }
  }
`;

const AddWizardMutation = gql`
  mutation addWizard($input: AddWizardInput!) {
    addWizard(input: $input) {
      ...wizardBodyFragment
      currentQuestionnaire {
        ...questionnaireFragment
      }
      questionnaires {
        ...basicQuestionnaireInfoFragment
      }
    }
  }

  fragment wizardBodyFragment on Wizard {
    constraints {
      minValue
      maxValue
      scope
      reference
      warningMessage
    }
    languageCode
    nodes {
      id
      parentId
      kind
      position
      folderName
      folderDescription
      originId
    }
    projectNodeId
    projectId
    currentStep
    totalSteps
    availableSteps
    subType
    topology
    fieldKeyGroup
  }

  fragment questionnaireFragment on Questionnaire {
    ...basicQuestionnaireInfoFragment
    ...questionsFragment
  }

  fragment basicQuestionnaireInfoFragment on Questionnaire {
    title
    description
    info
    position
    id
  }

  fragment questionsFragment on Questionnaire {
    questions {
      title
      identifier
      position
      description
      info
      iconName
      fieldGroups {
        title
        key
      }
      constraints {
        scope
        reference
        minValue
        maxValue
        warningMessage
      }
      fields {
        title
        fieldGroupId
        fieldKey
        fieldValue
        fieldType
        fieldInputType
        fieldDefaultValue
        fieldMin
        fieldMax
        values
        enabled
        onAction {
          fieldValueChange {
            newValue
            states {
              fieldKey
              fieldValue
              fieldMax
              fieldMin
              fieldInputType
              fieldKeyGroup
              enabled
            }
          }
        }
        iconName
      }
    }
  }
`;

const WizardDeleteMut = `
  mutation removeWizard($input: RemoveWizardInput!) {
    removeWizard(
      input: $input
    ) {
      status
      message
    }
  }
`;

export {
  AddWizardMutation,
  WizardStepMut,
  createWizardStepQuestionnaire,
  updateWizardStepQuestionnaireMut,
  changeWizardActiveQuestionnaireMut,
  deleteWizardStepQuestionnaireMut,
  duplicateWizardStepQuestionnaireMut,
  WizardDeleteMut,
};
